<template>
    <div class="home content is-large">
        <p class="subtitle is-3">Created by students in the Houston area, Creek Coding strives to promote CS literacy
            through a variety of programs focusing on project based learning. We focus especially on addressing the
            growing number of students wanting to learn how to code by sharing our knowledge with those around us.</p>
        <h1>Our Philosophy: <i>Anyone Can Learn To Code</i></h1>
        <p>We believe that anyone should be able to have access to high quality instructional content to learn to code
            from scratch.
            We know that simply reading textbooks isn't the way to learn coding. It's boring and you make slow progress.
            Aiming to teach through <b>Project Based Learning</b>, we practice and learn new skills by making. At Hack
            Club,
            students are encouraged to build projects every week. Lightbulb Education Code provides high-quality,
            beginner focused
            tutorials on how to make simple but fun projects.</p>
        <h1>Why you should learn how to code</h1>
        <ul>
            <li>It helps teach problem solving and critical thinking skills.</li>
            <li>It turns you from a consumer into a creator, empowering you to change the world.</li>
            <li>It's fun! (Oh and it's also a very lucrative career path)</li>
        </ul>
        <p>Of course, coding isn't for everyone. <b>But you won't know until you try</b>. And even if you don't choose
            it as a career path, you'll still have a valuable skill for the future</p>
        <h1>How to get involved</h1>
        <p>If you're a student at any of the schools we serve (<router-link to="/hackschs">SCHS</router-link> &
            <router-link to="/hackwms">WMS</router-link>), come
            to our Hack Club sessions! If you're around our area, talk to your teacher about starting a coding club and
            we can work with them to get one going! And finally, if you're not from around here, check out our online
            learning options. Learn on your own with fun projects at
            <a href="https://code.lightbulb.education" target="_blank">Lightbulb Education Code</a>, or binge videos
            from
            our YouTube channel <a href="https://www.youtube.com/channel/UCHeRnkORi2B3G4kbSyhBtqA" target="_blank">byteCode</a>!
        </p>
        <p>Are you a company interested in equiping the next generation with the skills necessary to succeed in an
            increasingly tech-focused workplace? Reach out to us at <a href="mailto:contact@creekcoding.com">contact@creekcoding.com</a>.
        </p>

    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'Home',
        components: {}
    }
</script>
